import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Icon from '../AppIcon';

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    // Default theme: dark (only use light if user explicitly chose it)
    if (savedTheme === 'light') {
      setIsDark(false);
      document.documentElement.classList.remove('dark');
    } else {
      setIsDark(true);
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    
    if (newTheme) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  return (
    <motion.button
      onClick={toggleTheme}
      className="relative w-12 h-6 bg-muted rounded-full p-1 transition-colors duration-300 hover:bg-muted/80"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <motion.div
        className="w-4 h-4 bg-primary rounded-full shadow-sm"
        animate={{
          x: isDark ? 24 : 0,
          rotate: isDark ? 180 : 0,
        }}
        transition={{
          type: "spring",
          stiffness: 500,
          damping: 30,
        }}
      >
        <div className="w-full h-full flex items-center justify-center">
          {isDark ? (
            <Icon name="Sun" size={12} className="text-primary-foreground" />
          ) : (
            <Icon name="Moon" size={12} className="text-primary-foreground" />
          )}
        </div>
      </motion.div>
    </motion.button>
  );
};

export default ThemeToggle;
